<script>
    // -- IMPORTS
    
    import { getLocalizedText, getProcessedMultilineText, isString } from "senselogic-gist";
    import Modal from "../../../../../ADMIN/src/lib/component/element/Modal.svelte";
    import BlockManager from "../../../../../ADMIN/src/lib/component/element/BlockManager.svelte";
    import AdminEditButton from "../element/AdminEditButton.svelte";
    import AnimatedContainer from "../element/AnimatedContainer.svelte";
    import { fetchData, getProcessedMultilineTranslatedText } from "$src/lib/base";
    import { languageTagStore } from "$src/lib/store/languageTagStore";
    import { enabledAdminView } from "$src/lib/store/adminStore";
    import { getImagePath } from "$src/lib/filePath";
    import { Link } from "svelte-routing";
    import Media from "../element/Media.svelte";

    // -- VARIABLES

    /** @type {{block?: any, blockIndex?: number, onDeleteBlock: (blockId, slug) => void }} */
    let { block = $bindable({}), blockIndex = 0, onDeleteBlock = ( blockId, slug ) => {} } = $props();

    let blockBeingEdited = $state({});
    let isEditBlockModalOpen = $state(false);

    // -- FUNCTIONS

    async function loadData(
        )
    {
        
        let blockData =
            await fetchData(
                '/api/block/get-block-by-id',
                {
                    method: 'POST',
                    body: JSON.stringify(
                        {
                            id: block.id,
                        }
                    ),
                    headers: { 'Content-Type': 'application/json' }
                }
                );

        block = blockData.block;
    }

    // ~~

    function dispatchEditEvent(
        )
    {
        let event = new CustomEvent(
            'on-edit-block',
            {
                bubbles: true
            }
        );

        document.dispatchEvent(event);
    }

    // ~~

    async function saveBlockData(
        )
    {
        isEditBlockModalOpen = false;
        dispatchEditEvent();
        loadData();
    }

    // ~~

    async function handleEditBlock(
        block 
        )
    {
        blockBeingEdited = block;
        isEditBlockModalOpen = true;
    }

    // ~~

    function isSvg( 
        imagePath 
        )
    {
        if( isString( imagePath ) )
        {
            return imagePath.endsWith('.svg')
        }
    }
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // CLASSES

    .what-is-bamhub-card
    {
        width: 100%;
        height: 100%;
        padding-bottom: 2.7rem;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        gap: 1.5rem;

        background: grayColor500;

        cursor: pointer;
        transition: scale 200ms ease-in-out;
    }

    .is-icon-image
    {
        padding: 2.70rem 1.5rem;
    }

    .what-is-bamhub-card:hover
    {
        +media( desktop )
        {
            scale: 1.05;
        }
    }
    
    .card-header
    {
        width: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1.5rem;
    }

    .what-is-bamhub-icon-label,
    .card-text
    {
        width: 100%;
    }

    .what-is-bamhub-icon-label
    {
        min-height: 4.65rem;

        text-align: center;
        text-transform: uppercase;
        line-break: normal;
        font-size: 24px;
        line-height: 28px;
        color: lightGoldColor;
    }

    .card-text
    {
        width: 100%;
        height: 100%;
        margin-top: .5rem;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        font-size: 1rem;
        line-height: 1.5rem;
        text-align: center;
    }

    :global( .bullet-1 )
    {
        text-align: left;
    }

    .card-text :global( .paragraph:last-child )
    {
        min-height: 4rem;
    }

    .card-cta
    {
        font-size: 16px;
        line-height: 24px;
        color: lightGoldColor;
        text-decoration: underline;
    }

    .what-is-bamhub-card:hover .card-image
    {
        background: grayColor500;
    }

    .card-image
    {
        height: 4rem;
    }

    .card-media-section
    {
        width: 100%;
        aspect-ratio: 3/1;
    }
</style>

<Modal
    bind:showModal={ isEditBlockModalOpen }
    modalConfirmButtonLabel="Save"
    modalType=""
    hasFooterButtons={ false }
    modalTitle="Edit Block"
>
    <BlockManager
        blockData={ blockBeingEdited }
        onBlockSaved={ saveBlockData }
    />
</Modal>

<AnimatedContainer style="width: 100%;" delay="{ blockIndex * 100 }ms">
    <AdminEditButton
        handleAdminButton={ () => handleEditBlock( block ) }
        title={ getLocalizedText( block.title, $languageTagStore ) }
        blockId={ block.id }
        slug={ block.slug }
        blockMediaPath={ block.mediaPath }
        onDelete={ onDeleteBlock }
    />

    <Link to={ 'partners#' + block.href } >
        <div 
            class="what-is-bamhub-card" 
            class:is-admin-enabled={ $enabledAdminView }
            class:is-icon-image={ isSvg( block.mediaPath ) }
        >
            <div class="card-header">
                {#if block.mediaPath || block.mediaPathArray}
                    {#if ( isSvg( block.mediaPath ) )}
                        <img 
                            class="card-image" 
                            src="{ getImagePath( block.mediaPath ) }" 
                            alt={ getLocalizedText( block.title, $languageTagStore ) }
                        /> 
                    {:else}
                        <div class="card-media-section">
                            <Media
                                mediaPath={ block.mediaPathArray?.length > 0 ? block.mediaPathArray : block.mediaPath }
                                mediaClass="card-media"
                                mediaId={ block.id }
                            />
                        </div>
                    {/if}
                {/if}
                
                {#if block?.title}
                    <h3 class="what-is-bamhub-icon-label">{@html getProcessedMultilineTranslatedText( block.title, $languageTagStore )}</h3>
                {/if}
            </div>

            {#if block?.text}
                <p class="font-size-150 font-weight-500 color-gray card-text">
                    {@html getProcessedMultilineText( block.text, $languageTagStore )}
                </p>
            {/if}
           
            {#if block?.teaser}
                <p class="font-size-150 font-weight-500 color-gray card-cta">
                    {@html getProcessedMultilineText( block.teaser, $languageTagStore )}
                </p>
            {/if}
        </div>
    </Link>
</AnimatedContainer>